export default __webpack_public_path__ + "static/media/food2.203fa15f.jpg";